import Swiper from '../../../node_modules/swiper/js/swiper';

export default function v1TopCarouselSeason() {
  if (!document.getElementsByClassName('v1-top-carousel--season')) {
    return;
  }
  const mySwiper = new Swiper('.v1-top-carousel--season .swiper-container', {// eslint-disable-line
    speed: 1000,
    loop: true,
    effect: 'fade',
    // A11y http://idangero.us/swiper/api/#a11y
    // Autoplay http://idangero.us/swiper/api/#autoplay
    // autoplay: false,
    autoplay: {
      delay: 3000,
    },
  });

  /**
   * ボタンをクリックするとカルーセルの停止・開始を切り替わる。
   */
  const toggle = document.getElementById('v1-top-interests__toggle-button');
  if (!toggle) {
    return;
  }
  toggle.addEventListener('click', e => {
    e.preventDefault();

    const isAutoplay = !!mySwiper.autoplay.running;

    if (isAutoplay) {
      mySwiper.autoplay.stop();
      toggle.classList.add('-stop');
      toggle.classList.remove('-play');
      return;
    }

    mySwiper.autoplay.start();
    toggle.classList.add('-play');
    toggle.classList.remove('-stop');
  });
}
